export const state = () => ({
  masterProductList: [],
  masterProductListCancelToken: null,
  masterFeatureList: [],
  masterTagList: []
});
